// React Query hook for the dashboard bar feed. Polls every 10 s while the tab
// is visible — `refetchIntervalInBackground: false` matches legacy parity.
import { useQuery } from "@/lib/query";
import {
  fetchMatrixStats,
  type AggregatedMatrixStats,
  type MatrixStatsPeriod,
} from "./api";
import { matrixStatsKeys } from "./keys";

const REFRESH_MS = 10_000;

/** Poll `/api/v2/admin/matrix-stats?period` and pause when the tab is hidden. */
export function useMatrixStats(period: MatrixStatsPeriod = "1h") {
  return useQuery<AggregatedMatrixStats>({
    queryKey: matrixStatsKeys.summary(period),
    queryFn: () => fetchMatrixStats(period),
    refetchInterval: REFRESH_MS,
    refetchIntervalInBackground: false,
  });
}
